import type { Component, Entity2D } from '../../odie';

import { CountBlockOptionDef, ChocolateEggBlockProps } from '../defs/block';
import { ChocolateEggBlockView } from '../views/blocks/ChocolateEggBlockView';

// types
//-----------------------------------------------------------------------------
export type ChocolateEggBlockComponentOptions = {
  props: ChocolateEggBlockProps;
  option?: number;
};

/*
    chocolate egg block component
*/
export class ChocolateEggBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockChocolateEgg';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ChocolateEggBlockView;

  // properties
  //-------------------------------------------------------------------------
  private props!: ChocolateEggBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    // update view
    this.view.count = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: ChocolateEggBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;

    // create view
    this.view = new ChocolateEggBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
